import { useQuery } from '@tanstack/react-query';

import { standbyPublicEntryQuery } from '@/api/standby/standbyPublicEntryQuery';

import type { UseStandbyPublicEntryQueryOptions } from './types';

export const useStandbyPublicEntryQuery = (
  entryId?: string,
  options?: UseStandbyPublicEntryQueryOptions,
) =>
  useQuery({
    ...standbyPublicEntryQuery(entryId),
    ...options,
    // A caller's `enabled` must never re-open the factory's required-id guard —
    // matches useStandbyActiveEntryQuery/useStandbyPublicShopQuery.
    enabled: !!entryId && (options?.enabled ?? true),
  });
